import { render, staticRenderFns } from "./PathDrawer.vue?vue&type=template&id=6df06572&scoped=true"
import script from "./PathDrawer.vue?vue&type=script&lang=js"
export * from "./PathDrawer.vue?vue&type=script&lang=js"
import style0 from "./PathDrawer.vue?vue&type=style&index=0&id=6df06572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df06572",
  null
  
)

export default component.exports